import { render, staticRenderFns } from "./ProjectGroup.vue?vue&type=template&id=11b0b67d&scoped=true&"
import script from "./ProjectGroup.vue?vue&type=script&lang=ts&"
export * from "./ProjectGroup.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectGroup.vue?vue&type=style&index=0&id=11b0b67d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b0b67d",
  null
  
)

export default component.exports